const activeGameIdReducer = (
    state = 0,
    action
  ) => {
    switch (action.type) {
      case "SET_ACTIVE_GAME_ID":
        return action.activeGameId;
      case "RESET_ACTIVE_GAME_ID":
        return 0;
      default:
        return state;
    }
  };
  
  export default activeGameIdReducer;
  